import { insertContent } from './insert'
import { convertHtmlToFormattedText } from './convert'
import {
  getRange,
  getCaretContainingLineNode,
  putCaretAtEndOfEditor,
  refreshRange,
  scrollToCursor,
} from './utils'
import { copyToClipboard } from '$func/clipboard'

export function copySelectedContentToClipboard(shouldCut = false) {
  const range = getRange()
  if (!range) return

  if (range.collapsed) return
  const selectedContentText = convertHtmlToFormattedText(
    shouldCut ? range.extractContents() : range.cloneContents(),
    false,
  )

  copyToClipboard(selectedContentText)
  refreshRange(range)
  return
}

export function pasteContentToEditor(
  content: string,
  editorElement: HTMLDivElement,
) {
  if (!content) return

  const range = getRange()
  if (!range) putCaretAtEndOfEditor(editorElement)

  insertContent(editorElement, content)
  scrollToCursor()
}
